import { render, staticRenderFns } from "./ReturnWayToggler.vue?vue&type=template&id=226cb82e&scoped=true&"
import script from "./ReturnWayToggler.vue?vue&type=script&lang=js&"
export * from "./ReturnWayToggler.vue?vue&type=script&lang=js&"
import style0 from "./ReturnWayToggler.vue?vue&type=style&index=0&id=226cb82e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226cb82e",
  null
  
)

export default component.exports